"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Badge = _interopRequireDefault(require("@match/react-component-library/components/Badge"));

var _Image = _interopRequireDefault(require("@match/react-component-library/components/Image"));

var _reactIntl = require("react-intl");

var _constants = require("@match/react-component-library/components/theme/constants");

var _theming = _interopRequireWildcard(require("../../../utils/theming"));

var _ = require("../");

var _menu = require("../menu");

var _subMenu = require("../sub-menu");

var _messages = require("../../../constants/messages");

var _routes = require("../../../constants/routes");

var _VisuallyHidden = _interopRequireDefault(require("@match/react-component-library/components/VisuallyHidden"));

var ProfileMenu = function ProfileMenu(_ref) {
  var activeListItem = _ref.activeListItem,
      activeHoverListItem = _ref.activeHoverListItem,
      isUpgradeToPremiumEligible = _ref.isUpgradeToPremiumEligible,
      customLinkRenderer = _ref.customLinkRenderer,
      eliteBenefitsCount = _ref.eliteBenefitsCount,
      onItemMouseEnter = _ref.onItemMouseEnter,
      onItemMouseLeave = _ref.onItemMouseLeave,
      primaryPhotoUri = _ref.primaryPhotoUri,
      showBoost = _ref.showBoost,
      showEliteBenefits = _ref.showEliteBenefits,
      showSafetyCenter = _ref.showSafetyCenter,
      showSubscriberBenefits = _ref.showSubscriberBenefits,
      showViewedMe = _ref.showViewedMe,
      subscriberBenefitsCount = _ref.subscriberBenefitsCount,
      totalCount = _ref.totalCount,
      viewedMeCount = _ref.viewedMeCount;
  var isActive = _.NAV_MENUS.PROFILE_SELF === activeListItem;
  return _react.default.createElement(_theming.ClassNames, null, function (_ref2) {
    var css = _ref2.css;
    return _react.default.createElement(_menu.MenuItem, {
      as: "div",
      buttonClassName: css(iconAdjustment),
      count: viewedMeCount,
      className: css(iconNavMenuItem),
      customLinkRenderer: customLinkRenderer,
      hideLabel: true,
      id: _.NAV_MENUS.PROFILE_SELF,
      isSelected: isActive,
      label: _messages.MESSAGE_ID.PROFILE_SUB_MENU,
      noSelectionUnderline: true,
      onMouseEnter: onItemMouseEnter,
      onMouseLeave: onItemMouseLeave,
      activeHoverListItem: activeHoverListItem,
      route: _routes.ROUTE.PROFILE_EDIT,
      showIndicatorDot: false,
      subMenuUI: _react.default.createElement(_subMenu.SubMenu, {
        align: _subMenu.ALIGNMENT.RIGHT
      }, _react.default.createElement(_subMenu.SubNavItem, {
        key: "profileDashboard"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.PROFILE_SUB_MENU,
        route: _routes.ROUTE.PROFILE_EDIT
      })), showViewedMe && _react.default.createElement(_subMenu.SubNavItem, {
        key: "viewedMe"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        count: viewedMeCount,
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.VIEWED_ME_SUB_MENU,
        route: _routes.ROUTE.INTERESTS_VIEWS
      })), showBoost && _react.default.createElement(_subMenu.SubNavItem, {
        key: "boost"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.BOOST_SUB_MENU,
        route: _routes.ROUTE.SUBSCRIBE_BOOST
      })), showSubscriberBenefits && _react.default.createElement(_subMenu.SubNavItem, {
        key: "subscriberBenefits"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        count: subscriberBenefitsCount,
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.SUBSCRIBER_BENEFITS_SUB_MENU,
        route: _routes.ROUTE.SUBSCRIBE_PREMIUM_BENEFITS
      })), showSafetyCenter && _react.default.createElement(_subMenu.SubNavItem, {
        key: "safetyCenter"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.SAFETY_CENTER,
        route: _routes.ROUTE.SAFETY_CENTER
      })), showEliteBenefits && _react.default.createElement(_subMenu.SubNavItem, {
        key: "eliteBenefits"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        count: eliteBenefitsCount,
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.ELITE_BENEFITS_SUB_MENU,
        route: _routes.ROUTE.ELITE_BENEFITS
      })), isUpgradeToPremiumEligible && _react.default.createElement(_subMenu.SubNavItem, {
        key: "upgradeToPremium"
      }, _react.default.createElement(_subMenu.SubMenuItem, {
        pageCode: "upgrade_me_dashboard_tapped",
        customLinkRenderer: customLinkRenderer,
        label: _messages.MESSAGE_ID.UPGRADE_TO_PREMIUM,
        route: "".concat(_routes.ROUTE.UPGRADE_TO_PREMIUM_BILLING, "&returnUrl=").concat(location.pathname).concat(location.search)
      })))
    }, _react.default.createElement(ThemedBadge, {
      count: totalCount
    }, _react.default.createElement(_VisuallyHidden.default, null, _react.default.createElement(_reactIntl.FormattedMessage, {
      id: _messages.MESSAGE_ID.PROFILE_SUB_ALT_TEXT
    })), _react.default.createElement(_Image.default, {
      "aria-hidden": true,
      height: 24,
      shape: "round",
      src: primaryPhotoUri,
      width: 24
    })));
  });
};

var ThemedBadge = (0, _theming.default)(_Badge.default)(function (props) {
  return {
    zIndex: props.theme.zIndex[_constants.ZINDEX.NAV]
  };
});
var iconAdjustment = {
  justifyContent: 'center',
  paddingTop: 0
};
var iconNavMenuItem = (0, _theming.css)({
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  width: 64
});
var _default = ProfileMenu;
exports.default = _default;